import { WorkflowMetricsOverviewResponseView } from "../../app/GeneratedApi";
import { Metric } from "../../components/MetricCard/MetricCard.types";
import { WorkflowFilterView, WorkflowsNav } from "./WorkflowsPage.types";
import { formatAmount, formatNumber } from "@tiny/utils/formatUtils";
import { v4 as uuid } from "uuid";

export interface PageTabItem<T extends string> {
  name: T;
  props?: { [key: string]: any };
}

export const workflowsNav: PageTabItem<WorkflowsNav>[] = [
  { name: "All" },
  { name: "Live" },
  { name: "Paused" },
  { name: "Draft" },
];

export function mapToWorkflowStatuses(
  tab: string
): WorkflowFilterView["workflowStatuses"] {
  switch (tab) {
    case "Live":
      return ["ACTIVE"];
    case "Paused":
      return ["PAUSED"];
    case "Draft":
      return ["DRAFT"];
    case "Launched":
    default:
      return ["DRAFT", "ACTIVE", "PAUSED"];
  }
}

function totalMapper(input: number, currency: string): Metric {
  return {
    title: "Total Revenue",
    value: typeof input === "undefined" ? "N/A" : formatAmount(input, currency),
    image:
      "https://tinyemail-stripo.s3.ca-central-1.amazonaws.com/static/workflow/revenue.svg",
    id: uuid(),
  };
}

function generatedConversionMapper(input: number): Metric {
  return {
    title: "No. of Orders Attributed to Revenue",
    value: typeof input === "undefined" ? "N/A" : formatNumber(input),
    image:
      "https://tinyemail-stripo.s3.ca-central-1.amazonaws.com/static/workflow/generated-con.svg",
    id: uuid(),
  };
}

function generatedRevenueMapper(input: number, currency: string): Metric {
  return {
    title: "Generated Revenue",
    value: typeof input === "undefined" ? "N/A" : formatAmount(input, currency),
    image:
      "https://tinyemail-stripo.s3.ca-central-1.amazonaws.com/static/workflow/generated-rev.svg",
    id: uuid(),
  };
}

function sentMapper(input: number): Metric {
  return {
    title: "Email sent",
    value: typeof input === "undefined" ? "N/A" : formatNumber(input),
    image:
      "https://tinyemail-stripo.s3.ca-central-1.amazonaws.com/static/workflow/sent.svg",
    id: uuid(),
  };
}

function openMapper(input: number): Metric {
  return {
    title: "Email Opens",
    value: typeof input === "undefined" ? "N/A" : formatNumber(input),
    image:
      "https://tinyemail-stripo.s3.ca-central-1.amazonaws.com/static/workflow/opens.svg",
    id: uuid(),
  };
}

function clickedMapper(input: number): Metric {
  return {
    title: "Email clicks",
    value: typeof input === "undefined" ? "N/A" : formatNumber(input),
    image:
      "https://tinyemail-stripo.s3.ca-central-1.amazonaws.com/static/workflow/clicks.svg",
    id: uuid(),
  };
}

export function metricMapper(
  src: WorkflowMetricsOverviewResponseView | undefined,
  currency: string
): Metric[] {
  if (!src) {
    return [];
  }
  const { generatedRevenue, generatedConversion } = src;

  return [
    generatedRevenueMapper(generatedRevenue, currency),
    generatedConversionMapper(generatedConversion),
  ];
}
